import { Application } from '@raydiant/api-client-js';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';
import { ArrowLeft } from '@raydiant/raydial/components/Icons';
import cn from 'classnames';

interface ApplicationCardV2Props {
  application: Application;
  buttonClassName?: string;
  buttonContent?: React.ReactNode;
  onClick: () => void;
}

const ApplicationCardV2 = ({
  application,
  buttonClassName,
  buttonContent,
  onClick,
}: ApplicationCardV2Props) => {
  const appData = application.currentAppVersion;

  return (
    <div
      className="flex items-center p-3.5 gap-4 rounded-xl border border-gray-200 cursor-pointer w-full max-h-[66px]"
      onClick={onClick}
    >
      <img
        src={appData.iconUrl}
        className="w-9 h-9 rounded object-cover border border-gray-200"
        alt={`${appData.name}-logo`}
      />

      <div className="flex-grow overflow-hidden">
        <Text
          variant="largeSubtitle"
          className="block text-md md:text-lg truncate whitespace-nowrap overflow-hidden"
        >
          {appData.name}
        </Text>
      </div>

      <Button
        variant="unstyled"
        className={cn('mt-1 shrink-0', buttonClassName)}
        onPress={(e) => {
          (e as any).stopPropagation?.();
          onClick();
        }}
      >
        {buttonContent || <ArrowLeft className="rotate-180 text-black" />}
      </Button>
    </div>
  );
};

export default ApplicationCardV2;
